import { IconButton, Stack, Typography } from '@prenuvo/halo';
import { ChevronLeft } from '@prenuvo/halo-icon';

import { ExternalDocumentLink } from './patient-docs/patient-docs-list';
import { PATIENT_DOCS_SIDE_PANEL_TITLE_MAP } from './patient-docs-side-panel.constant';
import { PatientDocument } from './patient-docs-side-panel.model';

interface PatientDocsSidePanelTitleProps {
  onBackClick?: () => void;
  patientDocument?: PatientDocument;
}

export function PatientDocsSidePanelTitle({
  onBackClick,
  patientDocument,
}: PatientDocsSidePanelTitleProps) {
  if (patientDocument) {
    const { link, name } = patientDocument;

    return (
      <Stack className="w-full" justification="between">
        <Stack alignment="center" gap={3}>
          <IconButton icon={ChevronLeft} onClick={onBackClick} size="xs" variant="text" />

          <Typography translationKey={PATIENT_DOCS_SIDE_PANEL_TITLE_MAP[name]} variant="h5" />
        </Stack>

        <ExternalDocumentLink link={link} />
      </Stack>
    );
  }

  return <Typography translationKey="FCT.PATIENT_DOCS.SIDE_PANEL.TITLE" variant="h5" />;
}
